import React, {useEffect} from 'react'
import ProfileView from '../../pages/ProfileView/ProfileView'

export const ProfileViewMobile = (props) => {
  useEffect(() => props.setShow(false), [props]);
  return <ProfileView />
}